import React from 'react';

interface SendFileConfigProps {
  config: any;
  onChange: (key: string, value: any) => void;
}

export const SendFileConfig: React.FC<SendFileConfigProps> = ({ config, onChange }) => {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-blue-200 bg-blue-50 p-3 text-xs leading-relaxed text-blue-700 dark:border-blue-700 dark:bg-blue-950/40 dark:text-blue-100">
        <strong>Como funciona:</strong> Envia um arquivo (PDF, documento, planilha, etc.) para o usuário. Informe a URL pública do arquivo e opcionalmente um nome personalizado. O arquivo será baixado e enviado pelo chat do Bitrix24.
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-200">
          URL do Arquivo (Link Público)
        </label>
        <input
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:placeholder:text-slate-400"
          placeholder="https://exemplo.com/arquivo.pdf"
          value={config.fileUrl || ''}
          onChange={(e) => onChange('fileUrl', e.target.value)}
        />
        <div className="mt-2 rounded-md border border-blue-100 bg-blue-50 p-3 dark:border-blue-800 dark:bg-blue-950/50">
          <p className="mb-1 text-xs font-medium text-blue-800 dark:text-blue-100">
            Como pegar o link do Bitrix Drive:
          </p>
          <ol className="list-inside list-decimal space-y-1 text-xs text-blue-700 dark:text-blue-200">
            <li>Vá ao Bitrix24 Drive e encontre o arquivo</li>
            <li>Clique no arquivo e ative a opção "Link Público"</li>
            <li>Copie o link gerado e cole no campo acima</li>
          </ol>
        </div>
      </div>
       <div>
        <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-200">
           Nome do Arquivo (Opcional)
        </label>
        <input
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:placeholder:text-slate-400"
          placeholder="Ex: Contrato.pdf"
          value={config.fileName || ''}
          onChange={(e) => onChange('fileName', e.target.value)}
        />
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-slate-700 dark:text-slate-200">
          Legenda/Mensagem (Opcional)
        </label>
        <textarea
          className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 dark:placeholder:text-slate-400"
          rows={2}
          placeholder="Digite uma mensagem para acompanhar o arquivo..."
          value={config.caption || ''}
          onChange={(e) => onChange('caption', e.target.value)}
        />
      </div>
    </div>
  );
};
